import React from "react";

export default function Settings() {
  return (
    <div>
      <h2 className="mb-4">Settings</h2>
      <div className="card p-3 shadow-sm">
        <p>App and admin settings go here.</p>
      </div>
    </div>
  );
}
